
export const AppMenus = {

  navbarTopRight: [],
  navbarTopLeft: [],
  navbarSideLeft: [],
  gender: [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" }
  ],
  hasCompleted: [
    { value: "Yes", label: "Yes" },
    { value: "No", label: "No" }
  ],
  requestType: [
    { value: "Regular", label: "Regular" },
    { value: "Express", label: "Express" },
  ],
  status: [
    { value: "Pending", label: "Pending" },
    { value: "Processed", label: "Processed" },
    { value: "Accepted", label: "Accepted" },
    { value: "Rejected", label: "Rejected" },
    { value: "Uncompleted", label: "Uncompleted" },
    { value: "Completed", label: "Completed" },
    { value: "Closed", label: "Closed" },
    { value: "Paid", label: "Paid" },
    { value: "Approved", label: "Approved" },
    { value: "Declined", label: "Declined" },
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
    { value: "Opened", label: "Opened" },
    { value: "Processing", label: "Processing" },
    { value: "Ready", label: "Ready" },
    { value: "Sent", label: "Sent" },
    { value: "Read", label: "Read" },
    { value: "Failed", label: "Failed" },
    { value: "Reversed", label: "Reversed" },
    { value: "Refunded", label: "Refunded" },
    { value: "Success", label: "Success" }
  ],
  currentSemester: [
    { value: 1, label: "First Semester" },
    { value: 2, label: "Second Semester" }
  ],

  Semester: [
    { value: 1, label: "First Semester" },
    { value: 2, label: "Second Semester" }
  ],
  level: [
    {
      label: 'Institution',
      items: [
        { value: 100, label: "L100" },
        { value: 200, label: "L200" },
        { value: 300, label: "L300" },
        { value: 400, label: "L400" },
        { value: 500, label: "L500" },
        { value: 600, label: "L600" },
      ]
    },
    {
      label: 'Coventry',
      items: [
        { value: 4, label: "L4" },
        { value: 5, label: "L5" },
        { value: 6, label: "L6" },
      ]
    },
  ],

  national_id_typeItems: [
    { value: "Ghana Card", label:"Ghana Card" },
    { value: "Ghana Card", label: "Ghana Card" },
    { value: "Birth Certificate", label: "Birth Certificate" },
    { value: "NHIS", label: "NHIS" }
],


  exportFormats: {
    print: {
      label: 'Print',
      icon: 'pi pi-print',
      type: 'print',
      ext: 'print',
    },
    // pdf: {
    //   label: 'Pdf',

    //   icon: 'pi pi-file-pdf',
    //   type: 'pdf',
    //   ext: 'pdf',
    // },
    excel: {
      label: 'Excel',
      icon: 'pi pi-file-excel',
      type: 'excel',
      ext: 'xlsx',
    },
    csv: {
      label: 'Csv',
      icon: 'pi pi-table',
      type: 'csv',
      ext: 'csv',
    },
  },

}
